
define('modules/application/wizard/steps/zoneStep/thermoZoneStep/zoneCollection',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",
  "../zoneCollection",
  "./zoneModel"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneCollection,
  ZoneModel) {

  var thermoZoneCollection     = ZoneCollection.extend({

    addConstructors                       : function()  {
      ZoneCollection.prototype.addConstructors.apply(this);
      this.ZoneModel = ZoneModel;
    },

    thereIsOneClimavenetaProductAtLeast   : function()  {
      var theresOneClimavenetaProduct = false;

      for (var i=0; i<this.models.length; i++) {
        if (this.models[i].gotOneClimavenetaProductAtLeast()) {
          theresOneClimavenetaProduct = true;
          break;
        }
      }

      return theresOneClimavenetaProduct;
    },

    thereIsOneEcoFunctionActivatedAtLeast : function() {
      var theresOneEcoFunctionActivated = false;

      for (var i=0; i<this.models.length; i++) {
        if (this.models[i].gotActivatedEcoFunction()) {
          theresOneEcoFunctionActivated = true;
          break;
        }
      }

      return theresOneEcoFunctionActivated;
    },

    removeClimavenetaProducts             : function() {
      for (var i=0; i<this.models.length; i++)
        this.models[i].removeClimavenetaProducts();
    },

    disableAllEcoFunctions                : function() {
      for (var i=0; i<this.models.length; i++)
        this.models[i].disableEcoFunction();
    }
  });

  // Required, return the module for AMD compliance
  return thermoZoneCollection;

});